import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import { ISingleCustomer, IUpdateCustomerBody, CustomersRequest, CustomersResponse, CustomerCreateRequest, CustomerCreateResponse, CustomerViewRequest, CustomerViewResponse } from "./types";
import { Customer } from "@/model/customers";

export const defaultCustomersExpand: Array<keyof Omit<Customer, "id" | "description" | "inn" | "name">> = [
  "business_area",
  "responsible_user",
  "created_by",
  "activities",
  "created_at"
];

export const customers = (data?: CustomersRequest): AxiosPromise<CustomersResponse> => {
  const { limit, offset, search, sort_column, sort_direction, ...rest } = data?.params?.filters || {};
  return axiosInstance.get(
    `/customers?expand=${data?.params?.expand?.length ? data?.params?.expand?.join(",") : defaultCustomersExpand.join(",")}`,
    {
      params: {
        limit, offset, search, sort_column, sort_direction, ...rest
      }
    }
  );
};

export const customerView = (data: CustomerViewRequest): AxiosPromise<CustomerViewResponse> =>
  axiosInstance.get(
    `/customer/${data.params.id}/view?expand=${data.params.expand?.join(",")}`
  );

export const customerCreate = (
  params: CustomerCreateRequest
): AxiosPromise<CustomerCreateResponse> =>
  axiosInstance.post(`/customer/create`, params);

export const updateCustomer = (
  id: number,
  params: IUpdateCustomerBody
): AxiosPromise<ISingleCustomer> =>
  axiosInstance.post(`/customer/${id}/update`, params);

export const deleteCustomer = (id: number): AxiosPromise<undefined> =>
  axiosInstance.post(`/customer/${id}/delete`);
